import { inject, injectable } from "../injection";
import { observable, action, makeObservable } from "mobx";
import { ConnectionStatus } from "./MessageBusClient";
import { MessageBusService } from "./MessageBusService";

@injectable("singleton")
export class ConnectionStatusStore {
    @observable public status?: ConnectionStatus;
    @observable public delaySeconds = 0;
    @observable public showOverlay = false;

    private updateInterval?: NodeJS.Timeout;
    private pastFirstConnecting = false;

    constructor(
        @inject(MessageBusService) private messageBusService: MessageBusService
    ) {
        makeObservable(this);

        this.messageBusService.getClient().subscribeToStatus(() => {
            this.update();
        });
        this.update();
    }

    private update(): void {
        this.updateStatus();
        if (this.updateInterval) {
            clearInterval(this.updateInterval);
            this.updateInterval = undefined;
        }
        if (this.status === "disconnected") {
            this.updateInterval = setInterval(() => {
                this.updateStatus();
            }, 250);
        }
    }

    @action
    private updateStatus(): void {
        const status = this.messageBusService.getClient().status();
        if (this.status === "connecting" && status.status !== "connecting") {
            // to avoid showing message when first connecting
            this.pastFirstConnecting = true;
        }
        this.status = status.status;
        this.delaySeconds = Math.ceil(status.attempConnectionDelay / 1000);
        this.showOverlay =
            !status.isInvalidated &&
            this.pastFirstConnecting &&
            (status.status === "connecting" ||
                status.status === "disconnected");
    }

    public attemptConnectionNow = () => {
        this.messageBusService.getClient().attemptConnectionNow();
    };
}
